import type { GlobalTranslations } from '../interfaces/global';

export const globalTranslations: GlobalTranslations = {
  input_error_invalid_email: 'Ingresa un correo válido.',
  input_error_required: 'Este campo es requerido',
  input_error_min_length:
    'Este campo debe tener al menos {{length}} caracteres',
  logout: 'Cerrar sesión',
  input_error_phone_indicative_required: 'El indicativo es requerido',
  input_error_phone_required: 'El número de télefono es requerido',
  input_error_phone_invalid:
    'El número de télefono no tiene un formato válido para el país seleccionado',
  input_error_register_code:
    'El formato debe ser xxxxxxxxxxxxxx== donde x son letras, números y símbolos.',
  input_error_not_terms: 'Debes aceptar nuestros términos y condiciones',
  error_login_credentials: 'Revisa tu usuario o contraseña.',
  successful_deletion_message: 'Se ha borrado correctamente.',
  successful_disabled_message: 'Se ha desactivado correctamente.',
  successful_active_message: 'Se ha activado correctamente.',
  successful_create_message: 'Se ha creado correctamente.',
  successful_update_message: 'Se ha actualizado correctamente.',
  error_token_message:
    'Se ha producido un error debido a la inexistencia o uso previo del token. Por favor, genera un nuevo token para continuar.',
  input_date_placeholder: 'Seleccioná una fecha',
  input_optional_label: '(opcional)',
  input_show_password_label: 'Mostrar contraseña',
  input_hide_password_label: 'Ocultar contraseña',
  input_search_placeholder: 'Buscar',
  input_phone_number_placeholder: 'Ingresa tu número de teléfono',
  input_phone_number_label: 'Número de teléfono',
  not_found_message: 'No se encontraron resultados',
  input_phone_label: 'Télefono',
  input_phone_placeholder: 'Ingresa el número de télefono',
  sidebar_settings_label: 'Ajustes',
  sidebar_customers_label: 'Clientes',
  sidebar_chats_label: 'Conversaciones',
  sidebar_reports_label: 'Reportes',
  sidebar_agents_label: 'Agentes',
  sidebar_products_label: 'Catálogo',
  sidebar_templates_label: 'Plantillas',
  sidebar_groups_label: 'Grupos',
  sidebar_meta_ads_label: 'Meta Ads',
  sidebar_account_label: 'Mi cuenta',
  sidebar_organization_label: 'Organización',
  sidebar_group_main_label: 'Principal',
  notifications_title: 'Notificaciones',
  notifications_empty_title: 'No tienes notificaciones',
  pagination_records: 'Mostrando {{from}} a {{to}} de {{total}} resultados',
  pagination_empty: 'Sin resultados',
  pagination_prev_page: 'Página anterior',
  pagination_next_page: 'Página siguiente',
  app_error_title: 'Algo salió mal',
  app_error_description:
    'No pudimos cargar esta pantalla. Ya recibimos el reporte y lo estamos revisando.',
  app_error_retry: 'Reintentar',
  impersonation_banner: 'Sesión de soporte: estás viendo la cuenta de {{email}}. Todo lo que cambies aquí cambia para el cliente.',
};
